import SFXRoundedButton from "../../SFXRoundedButton";
import React, {Fragment} from "react";
import OutboundPaymentService from "../../../services/payment/OutboundPaymentService";
import ApiOutboundPaymentInitRequest from "../../../domain/Transaction/payment/ApiOutboundPaymentInitRequest";
import ToastHelper from "../../../utils/ToastHelper";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SFXButtonComponent from "../../SFXButtonComponent";

export default class StitchPaymentButton extends React.Component {


    constructor(props, context) {
        super(props, context);
        this.className = this.props.isMobile ? "mobile" : "browser";
        this.stitchPaymentPartnerId = process.env.REACT_APP_STITCH_PAYMENT_PARTNER_ID
        this.stitchPaymentPartnerName = 'STITCH'
        this.state = {
            hasOpenAuth: false,
            loadingMax: true
        }
    }


    render() {
        if (this.state.hasOpenAuth) {
            return this.renderHasOpenAuthModal();
        }
        if (this.state.maxExceeded) {
            return this.renderMaxExceededModal();
        }
        return <Fragment>
            <SFXRoundedButton
                value={'Pay by Bank'}
                onClick={this.onPayButtonClicked.bind(this)}
                disabled={this.disabled}
            />
        </Fragment>
    }

    onPayButtonClicked() {
        let request = new ApiOutboundPaymentInitRequest(
            this.props.transaction.paymentReference,
            this.stitchPaymentPartnerName,
            'CUSTOMER_PORTAL'
        );
        OutboundPaymentService.initiatePayment(this.stitchPaymentPartnerId, this.props.transaction.transactionId, request).then(
            response => {
                if (response['error-code'] || response.errors) {
                    if (this.props.onError) {
                        this.props.onError(response);
                    } else {
                        ToastHelper.formatError(response)
                    }
                } else {
                    window.location = response.redirectUrl
                }
            }
        )
    }

    renderHasOpenAuthModal() {
        return <Fragment>
            <Modal isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader className={this.className + '_modal_header'}>
                    Payment Not Available
                </ModalHeader>
                <ModalBody>
                    It seems someone is already trying to pay for this transaction. <br/>
                    Please wait 5 minutes and try again.
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({hasOpenAuth: false})
                        }
                    }>
                        OK
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>
    }

    renderMaxExceededModal() {
        return <Fragment>
            <Modal isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader className={this.className + '_modal_header'}>
                    Payment Not Available
                </ModalHeader>
                <ModalBody>
                    {this.state.message} for this payment method.
                    Please either pay at one of our stores or reduce the transaction value to less than this amount
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({maxExceeded: false})
                        }
                    }>
                        OK
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>;
    }
}
